export const buildPath = (pathParts) => {
    return pathParts.join('/');
};
// `/sites/:id` and `/sites/:id/:tab` are the same page; comparisons that ask
// "am I on this record's full page" must tolerate the trailing tab segment.
export const isSameOrNestedPath = (pathname, basePath) => pathname === basePath || pathname.startsWith(`${basePath}/`);
